<script setup>
import CTAContactoAsesorCelular from "@/modules/public/components/CTAContactoAsesorCelular";
import useStoreCotizaciones from "@/store/cotizaciones";
import { storeToRefs } from "pinia";
import usePublicStore from "@/store/public";

const { plazoTotal } = useStoreCotizaciones();
const { cotizacionFinal } = storeToRefs(usePublicStore());

</script>

<template>
  <section class="py-7">
    <div class="col-md-10 mx-auto">
      <div class="w-100 bg-light py-8 rounded-3">
        <div class="col-md-7 mx-auto text-center">
          <h5>¡Gracias por confiar en Ventus!</h5>
          <h2 class="text-dark">
            Ya tienes la cotización<br />en tu bandeja de correo.
          </h2>
          <p class="text-lg text-dark mt-3">
            Nuestro objetivo es brindarte una solución de arrendamiento que
            se<br />
            adapte perfectamente a tus necesidades y expectativas.
          </p>
          <hr class="mt-5" />
          <p class="text-lg text-dark">
            ¿Estás de acuerdo con tu cotización?<br />Para continuar el proceso,
            aplica para tu pre-aprobar<br />tu línea de arrendamiento en Ventus.
          </p>

          <router-link
            :to="{
              name: 'cotizacion-publica-show',
              params: { token: cotizacionFinal.token },
              query: { plazo: plazoTotal() },
            }"
            target="_blank"
            class="btn btn-warning btn-lg text-dark text-lg rounded-pill fw-bold"
          >
            Pre-aprueba tu línea de arrendamiento
          </router-link>
        </div>
      </div>

      <div class="mt-10">
        <CTAContactoAsesorCelular />
      </div>
    </div>
  </section>
</template>
